var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('fragment', [_c('WTitle', {
    staticClass: "type2",
    attrs: {
      "tag-name": "h4"
    }
  }, [_vm._v(_vm._s(_vm.title))]), _c('div', {
    staticClass: "book_info_summary"
  }, [_c('div', {
    staticClass: "book_info_article"
  }, [_c('LineBreakElement', {
    staticClass: "summary_body",
    attrs: {
      "contents": _vm.contents
    }
  })], 1)])], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }